import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DashboardService } from 'src/app/service/events/dashboard.service';
import { BaseForm } from 'src/app/view/base-form';
import { build, pool } from 'src/app/common/classes/request-builder';
import { TrazabilidadApiService } from 'src/app/service/api/trazabilidad-api.service';
import { TrazabilidadFormDefinition } from './form-control/form-definition';
import { TrazabilidadModel } from 'src/app/models/stock/trazabilidad.model';
import { FincasApiService } from 'src/app/service/api/fincas-api.service';
import { VentasApiService } from 'src/app/service/api/ventas-api.service';
import { FormCommonApiService } from 'src/app/service/api/formcommon-api.service';
import { ReactiveFormBuilderComponent } from 'src/app/common/components/reactive-form-builder/form-builder.component';
import { ReactiveFormChangedField, ReactiveFormValue } from 'src/app/common/components/reactive-form-builder/interfaces/reactive-form-change.interface';

@Component({
    selector: 'app-trazabilidad-form',
    standalone: false,
    templateUrl: './trazabilidad-form.component.html',
    styleUrls: ['./trazabilidad-form.component.scss']
})
export class TrazabilidadFormComponent extends BaseForm<TrazabilidadModel> implements OnInit {

    @ViewChild(ReactiveFormBuilderComponent) builderRef?: ReactiveFormBuilderComponent<TrazabilidadModel>;

    public form!: TrazabilidadFormDefinition;
    public loadingData = true;
    public showCantidadMaceta = false;

    constructor(
        public trazabilidadApi: TrazabilidadApiService,
        public fincasApi: FincasApiService,
        public ventasApi: VentasApiService,
        public formCommonApi: FormCommonApiService,
        public override route: ActivatedRoute,
        public override router: Router,
        public dashboardEvents: DashboardService,
        private cdr: ChangeDetectorRef,
    ) {
        super(
            route,
            router,
            dashboardEvents,
            trazabilidadApi.trazabilidad.PUT,
            trazabilidadApi.trazabilidad.POST,
            'stock-trazabilidad',
            'Editar Trazabilidad',
            'Crear Trazabilidad',
            'Duplicar Trazabilidad'
        );
    }

    ngOnInit(): void {
        this.dropdownsFinalized = false;
        this.form = new TrazabilidadFormDefinition(
            this.getType(),
            this.getModel() as Record<string, string>,
            null
        );
        this.form.model = { ...this.form.model, ...this.getModel() };

        // Visibilidad inicial de cantidad_maceta_reciclada según el modelo cargado
        const macetaVal = this.form.model.maceta_reciclada as unknown;
        this.showCantidadMaceta = (macetaVal === true || macetaVal == 1);

        this.initFormData();
        this.softInit(this.getType());
    }

    public formChanges(
        formModel: ReactiveFormValue<TrazabilidadModel>, 
        lastChangedFieldName: ReactiveFormChangedField<TrazabilidadModel>
    ): void {
        this.form.model = formModel;
        this.form.tag = lastChangedFieldName;

        if (this.form.model.maceta_reciclada !== undefined) {
            const val = this.form.model.maceta_reciclada as unknown;
            this.form.model.maceta_reciclada = (val === true || val == 1) ? 1 : 0;
        }

        if (lastChangedFieldName === 'maceta_reciclada') {
            const isActive = this.form.model.maceta_reciclada === 1;
            this.showCantidadMaceta = isActive;
            setTimeout(() => {
                this.builderRef?.updateForm({ maceta_reciclada: isActive ? '1' : '0' }, false);
                this.cdr.detectChanges();
            }, 0);
            return;
        }

        this.dropdownLoadTrigger.next();
    }

    private initFormData(): Promise<void> {
        this.loadingData = true;

        return pool([
            build(this.ventasApi.compradoresGET, this.form.lists.proveedores, 'razon_social'),
            build(this.fincasApi.fincasGET, this.form.lists.fincas, 'nombre'),          // <-- nuevo
            build(this.fincasApi.sectoresGET, this.form.lists.sectores, ['nombre'], true),
            build(this.fincasApi.parcelasGET, this.form.lists.parcelas, ['nombre'], true),
            build(this.formCommonApi.cultivosGET, this.form.lists.cultivos, ['cultivo'], false, false),
            build(this.formCommonApi.variedadesGET, this.form.lists.variedades, ['variedad']),
        ], () => {
            this.loadingData = false;
        }).then(() => {
            this.dropdownsFinalized = true;
            this.dropdownLoadTrigger.next();
        }).catch((e: unknown) => {
            console.error('Error cargando datos del formulario de trazabilidad:', e);
            this.dropdownsFinalized = true;
        });
    }
}